
import { SwitchExample } from './examples/Switch.jsx' 
import { SwitchCellExample } from './examples/SwitchCell.jsx'
import { TextAreaExample } from './examples/Textarea.jsx'
import { InputExample } from './examples/Input.jsx'
import { EllipsisTextExample } from './examples/EllipsisText.jsx'
import { RippleExample } from './examples/Ripple.jsx'
import { CounterExample } from './examples/Counter.jsx'
import { CounterInButtonExample } from './examples/CounterInButton.jsx'
import { ContainerExample } from './examples/Container.jsx'
import { ProfileExample } from './examples/Profile.jsx'
import { SpinnerExample } from './examples/Spinner.jsx'
import { FlexExample } from './examples/Flex.jsx'
import { GridExample } from './examples/Grid.jsx'
import { AvatarCloseButtonExample } from './examples/AvatarCloseButton.jsx'
import { AvatarIconExample } from './examples/AvatarIcon.jsx'
import { AvatarImageExample } from './examples/AvatarImage.jsx'
import { AvatarOnlineDotExample } from './examples/AvatarOnlineDot.jsx'
import { AvatarOverlayExample } from './examples/AvatarOverlay.jsx'
import { AvatarTextExample } from './examples/AvatarText.jsx'
import { AvatarContainerExample } from './examples/AvatarContainer.jsx'
import { TypographyActionExample } from './examples/TypographyAction.jsx'
import { TypographyBodyExample } from './examples/TypographyBody.jsx'
import { TypographyDisplayExample } from './examples/TypographyDisplay.jsx'
import { TypographyHeadlineExample } from './examples/TypographyHeadline.jsx'
import { TypographyLabelExample } from './examples/TypographyLabel.jsx'
import { ButtonExample } from './examples/Button.jsx'
import { ButtonDefaultExample } from './examples/ButtonDefault.jsx'
import { ButtonLinkAsExample } from './examples/ButtonLinkAs.jsx'
import { CellActionExample } from './examples/CellAction.jsx'
import { CellActionAsLinkExample } from './examples/CellActionAsLink.jsx'
import { CellActionEllipsizedExample } from './examples/CellActionEllipsized.jsx'
import { CellHeaderExample } from './examples/CellHeader.jsx'
import { CellInputExample } from './examples/CellInput.jsx'
import { CellListExample } from './examples/CellList.jsx'
import { CellSimpleExample } from './examples/CellSimple.jsx'
import { CellSimpleTappableExample } from './examples/CellSimpleTappable.jsx'
import { CellSimpleAsLinkExample } from './examples/CellSimpleAsLink.jsx'
import { CellSimpleEllipsizedTitleExample } from './examples/CellSimpleEllipsizedTitle.jsx'
import { CellSimpleEllipsizedSubtitleExample } from './examples/CellSimpleEllipsizedSubtitle.jsx'
import { TypographyTitleExample } from './examples/TypographyTitle.jsx'
import { IconButtonExample } from './examples/IconButton.jsx'
import { PanelExample } from './examples/Panel.jsx'
import { PanelPrimaryExample } from './examples/PanelPrimary.jsx'
import { PanelSecondaryExample } from './examples/PanelSecondary.jsx'
import { IconButtonAsLinkExample } from './examples/IconButtonAsLink.jsx'

export const kitRegistry = {
    Button: ButtonExample,
    ButtonDefault: ButtonDefaultExample,
    ButtonLinkAs: ButtonLinkAsExample,
    CellAction: CellActionExample,
    CellActionAsLink: CellActionAsLinkExample,
    CellActionEllipsized: CellActionEllipsizedExample,
    CellHeader: CellHeaderExample,
    CellInput: CellInputExample,
    CellList: CellListExample,
    CellSimple: CellSimpleExample,
    CellSimpleTappable: CellSimpleTappableExample,
    CellSimpleAsLink: CellSimpleAsLinkExample,
    CellSimpleEllipsizedTitle: CellSimpleEllipsizedTitleExample,
    CellSimpleEllipsizedSubtitle: CellSimpleEllipsizedSubtitleExample,
    Switch: SwitchExample,
    SwitchCell: SwitchCellExample,
    Textarea: TextAreaExample,
    Input: InputExample,
    EllipsisText: EllipsisTextExample,
    Ripple: RippleExample,
    Counter: CounterExample,
    CounterInButton: CounterInButtonExample,
    Container: ContainerExample,
    Profile: ProfileExample,
    Spinner: SpinnerExample,
    Flex: FlexExample,
    Grid: GridExample,
    AvatarCloseButton: AvatarCloseButtonExample,
    AvatarIcon: AvatarIconExample,
    AvatarImage: AvatarImageExample,
    AvatarOnlineDot: AvatarOnlineDotExample,
    AvatarOverlay: AvatarOverlayExample,
    AvatarText: AvatarTextExample,
    AvatarContainer: AvatarContainerExample,
    TypographyAction: TypographyActionExample,
    TypographyBody: TypographyBodyExample,
    TypographyDisplay: TypographyDisplayExample,
    TypographyHeadline: TypographyHeadlineExample,
    TypographyLabel: TypographyLabelExample,
    TypographyTitle: TypographyTitleExample,
    IconButton: IconButtonExample,
    Panel: PanelExample,
    PanelPrimary: PanelPrimaryExample,
    PanelSecondary: PanelSecondaryExample,
    IconButtonAsLink: IconButtonAsLinkExample
}

